"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

exports.Currency = contract_wrappers_1.FundRaiseType;
exports.Version = contract_wrappers_1.ContractVersion;

var lodash_1 = require("lodash");

var StoType;

(function (StoType) {
  StoType["Simple"] = "Simple";
  StoType["Tiered"] = "Tiered";
})(StoType = exports.StoType || (exports.StoType = {}));
/**
 * Check if the argument is of type [[STOType]]
 */


function isStoType(type) {
  return typeof type === 'string' && (type === StoType.Tiered || type === StoType.Simple);
}

exports.isStoType = isStoType;
/**
 * Specifies possible types of errors in the SDK
 */

var ErrorCode;

(function (ErrorCode) {
  ErrorCode["IncompatibleBrowser"] = "IncompatibleBrowser";
  ErrorCode["FeatureNotEnabled"] = "FeatureNotEnabled";
  ErrorCode["NonBrowserEnvironment"] = "NonBrowserEnvironment";
  ErrorCode["MetamaskNotInstalled"] = "MetamaskNotInstalled";
  ErrorCode["UserDeniedAccess"] = "UserDeniedAccess";
  ErrorCode["WalletIsLocked"] = "WalletIsLocked";
  ErrorCode["ProcedureValidationError"] = "ProcedureValidationError";
  ErrorCode["FetcherValidationError"] = "FetcherValidationError";
  ErrorCode["TransactionRejectedByUser"] = "TransactionRejectedByUser";
  ErrorCode["TransactionReverted"] = "TransactionReverted";
  ErrorCode["FatalError"] = "FatalError";
  ErrorCode["UnexpectedReturnData"] = "UnexpectedReturnData";
  ErrorCode["UnexpectedEventLogs"] = "UnexpectedEventLogs";
  ErrorCode["InvalidUuid"] = "InvalidUuid";
  ErrorCode["InvalidAddress"] = "InvalidAddress";
  ErrorCode["InsufficientBalance"] = "InsufficientBalance";
  ErrorCode["InexistentModule"] = "InexistentModule";
  ErrorCode["IncorrectVersion"] = "IncorrectVersion";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
/**
 * Types of Procedures available in the SDK
 */


var ProcedureType;

(function (ProcedureType) {
  ProcedureType["UnnamedProcedure"] = "UnnamedProcedure";
  ProcedureType["ApproveErc20"] = "ApproveErc20";
  ProcedureType["TransferErc20"] = "TransferErc20";
  ProcedureType["CreateCheckpoint"] = "CreateCheckpoint";
  ProcedureType["EnableDividendManager"] = "EnableDividendManager";
  ProcedureType["EnableGeneralPermissionManager"] = "EnableGeneralPermissionManager";
  ProcedureType["EnableGeneralTransferManager"] = "EnableGeneralTransferManager";
  ProcedureType["EnableCountTransferManager"] = "EnableCountTransferManager";
  ProcedureType["EnablePercentageTransferManager"] = "EnablePercentageTransferManager";
  ProcedureType["LaunchSimpleSto"] = "LaunchSimpleSto";
  ProcedureType["LaunchTieredSto"] = "LaunchTieredSto";
  ProcedureType["CreateDividendDistribution"] = "CreateDividendDistribution";
  ProcedureType["CreateSecurityToken"] = "CreateSecurityToken";
  ProcedureType["DisableFeature"] = "DisableFeature";
  ProcedureType["FreezeIssuance"] = "FreezeIssuance";
  ProcedureType["ReclaimFunds"] = "ReclaimFunds";
  ProcedureType["ReserveSecurityToken"] = "ReserveSecurityToken";
  ProcedureType["WithdrawTaxes"] = "WithdrawTaxes";
  ProcedureType["UpdateDividendsTaxWithholdingList"] = "UpdateDividendsTaxWithholdingList";
  ProcedureType["SetDividendsWallet"] = "SetDividendsWallet";
  ProcedureType["PushDividendPayment"] = "PushDividendPayment";
  ProcedureType["PullDividendPayment"] = "PullDividendPayment";
  ProcedureType["ModifyDividendsDefaultExclusionList"] = "ModifyDividendsDefaultExclusionList";
  ProcedureType["AssignSecurityTokenRole"] = "AssignSecurityTokenRole";
  ProcedureType["AssignStoRole"] = "AssignStoRole";
  ProcedureType["ControllerTransfer"] = "ControllerTransfer";
  ProcedureType["ControllerRedeem"] = "ControllerRedeem";
  ProcedureType["TogglePauseSto"] = "PauseSto";
  ProcedureType["FinalizeSto"] = "FinalizeSto";
  ProcedureType["SetController"] = "SetController";
  ProcedureType["SetDocument"] = "SetDocument";
  ProcedureType["RemoveDocument"] = "RemoveDocument";
  ProcedureType["DisableController"] = "DisableController";
  ProcedureType["ModifyTokenholderData"] = "ModifyTokenholderData";
  ProcedureType["RevokeKyc"] = "RevokeKyc";
  ProcedureType["IssueTokens"] = "IssueTokens";
  ProcedureType["ToggleAllowPreIssuing"] = "ToggleAllowPreIssuing";
  ProcedureType["ToggleAllowBeneficialInvestments"] = "ToggleAllowBeneficialInvestments";
  ProcedureType["ModifyTieredStoData"] = "ModifyTieredStoData";
  ProcedureType["InvestInTieredSto"] = "InvestInTieredSto";
  ProcedureType["InvestInSimpleSto"] = "InvestInSimpleSto";
  ProcedureType["ModifyMaxHolderCount"] = "ModifyMaxHolderCount";
  ProcedureType["ModifyMaxHolderPercentage"] = "ModifyMaxHolderPercentage";
  ProcedureType["ModifyPercentageExemptions"] = "ModifyPercentageExemptions";
  ProcedureType["TransferSecurityTokens"] = "TransferSecurityTokens";
  ProcedureType["ToggleFreezeTransfers"] = "ToggleFreezeTransfers";
  ProcedureType["SignTransferData"] = "SignTransferData";
  ProcedureType["SignDisableControllerAck"] = "SignDisableControllerAck";
  ProcedureType["SignFreezeIssuanceAck"] = "SignFreezeIssuanceAck";
  ProcedureType["TransferOwnership"] = "TransferOwnership";
  ProcedureType["TransferReservationOwnership"] = "TransferReservationOwnership";
})(ProcedureType = exports.ProcedureType || (exports.ProcedureType = {}));
/**
 * Tag to distinguish transactions for display purposes
 */


var PolyTransactionTag;

(function (PolyTransactionTag) {
  PolyTransactionTag["Any"] = "Any";
  PolyTransactionTag["GetTokens"] = "GetTokens";
  PolyTransactionTag["ApproveErc20"] = "ApproveErc20";
  PolyTransactionTag["TransferErc20"] = "TransferErc20";
  PolyTransactionTag["ReserveSecurityToken"] = "ReserveSecurityToken";
  PolyTransactionTag["CreateSecurityToken"] = "CreateSecurityToken";
  PolyTransactionTag["CreateCheckpoint"] = "CreateCheckpoint";
  PolyTransactionTag["CreateErc20DividendDistribution"] = "CreateErc20DividendDistribution";
  PolyTransactionTag["SetErc20TaxWithholding"] = "SetErc20TaxWithholding";
  PolyTransactionTag["SetEtherTaxWithholding"] = "SetEtherTaxWithholding";
  PolyTransactionTag["SetDefaultExcluded"] = "SetDefaultExcluded";
  PolyTransactionTag["EnableDividends"] = "EnableDividends";
  PolyTransactionTag["EnableCappedSto"] = "EnableCappedSto";
  PolyTransactionTag["EnableTieredSto"] = "EnableTieredSto";
  PolyTransactionTag["EnableGeneralPermissionManager"] = "EnableGeneralPermissionManager";
  PolyTransactionTag["EnableGeneralTransferManager"] = "EnableGeneralTransferManager";
  PolyTransactionTag["EnableCountTransferManager"] = "EnableCountTransferManager";
  PolyTransactionTag["EnablePercentageTransferManager"] = "EnablePercentageTransferManager";
  PolyTransactionTag["DisableController"] = "DisableController";
  PolyTransactionTag["FreezeIssuance"] = "FreezeIssuance";
  PolyTransactionTag["DisableFeature"] = "DisableFeature";
  PolyTransactionTag["ReclaimDividendFunds"] = "ReclaimDividendFunds";
  PolyTransactionTag["WithdrawTaxWithholdings"] = "WithdrawTaxWithholdings";
  PolyTransactionTag["PushDividendPayment"] = "PushDividendPayment";
  PolyTransactionTag["PullDividendPayment"] = "PullDividendPayment";
  PolyTransactionTag["SetDividendsWallet"] = "SetDividendsWallet";
  PolyTransactionTag["AddDelegate"] = "AddDelegate";
  PolyTransactionTag["ChangePermission"] = "ChangePermission";
  PolyTransactionTag["ControllerTransfer"] = "ControllerTransfer";
  PolyTransactionTag["ControllerRedeem"] = "ControllerRedeem";
  PolyTransactionTag["PauseSto"] = "PauseSto";
  PolyTransactionTag["UnpauseSto"] = "UnpauseSto";
  PolyTransactionTag["FinalizeSto"] = "FinalizeSto";
  PolyTransactionTag["SetController"] = "SetController";
  PolyTransactionTag["SetDocument"] = "SetDocument";
  PolyTransactionTag["RemoveDocument"] = "RemoveDocument";
  PolyTransactionTag["ModifyKycDataMulti"] = "ModifyKycDataMulti";
  PolyTransactionTag["ModifyInvestorFlagMulti"] = "ModifyInvestorFlagMulti";
  PolyTransactionTag["IssueMulti"] = "IssueMulti";
  PolyTransactionTag["AllowPreMinting"] = "AllowPreMinting";
  PolyTransactionTag["RevokePreMinting"] = "RevokePreMinting";
  PolyTransactionTag["ChangeAllowBeneficialInvestments"] = "ChangeAllowBeneficialInvestments";
  PolyTransactionTag["ModifyTimes"] = "ModifyTimes";
  PolyTransactionTag["ModifyFunding"] = "ModifyFunding";
  PolyTransactionTag["ModifyAddresses"] = "ModifyAddresses";
  PolyTransactionTag["ModifyTiers"] = "ModifiyTiers";
  PolyTransactionTag["ModifyLimits"] = "ModifyLimits";
  PolyTransactionTag["ModifyOracles"] = "ModifyOracles";
  PolyTransactionTag["BuyWithScRateLimited"] = "BuyWithScRateLimited";
  PolyTransactionTag["BuyWithPolyRateLimited"] = "BuyWithPolyRateLimited";
  PolyTransactionTag["BuyWithEthRateLimited"] = "BuyWithEthRateLimited";
  PolyTransactionTag["BuyTokens"] = "BuyTokens";
  PolyTransactionTag["BuyTokensWithPoly"] = "BuyTokensWithPoly";
  PolyTransactionTag["ChangeHolderCount"] = "ChangeHolderCount";
  PolyTransactionTag["ChangeHolderPercentage"] = "ChangeHolderPercentage";
  PolyTransactionTag["ModifyWhitelistMulti"] = "ModifyWhitelistMulti";
  PolyTransactionTag["SetAllowPrimaryIssuance"] = "SetAllowPrimaryIssuance";
  PolyTransactionTag["TransferSecurityTokens"] = "TransferSecurityTokens";
  PolyTransactionTag["UnfreezeTransfers"] = "UnfreezeTransfers";
  PolyTransactionTag["FreezeTransfers"] = "FreezeTransfers";
  PolyTransactionTag["Signature"] = "Signature";
  PolyTransactionTag["TransferReservationOwnership"] = "TransferReservationOwnership";
  PolyTransactionTag["TransferOwnership"] = "TransferOwnership";
})(PolyTransactionTag = exports.PolyTransactionTag || (exports.PolyTransactionTag = {}));
/**
 * Check whether the arguments are of type [[InvestWithStableCoinArgs]]
 */


function isInvestWithStableCoinArgs(args) {
  var currency = args.currency,
      stableCoinAddress = args.stableCoinAddress;
  return currency === contract_wrappers_1.FundRaiseType.StableCoin && typeof stableCoinAddress === 'string';
}

exports.isInvestWithStableCoinArgs = isInvestWithStableCoinArgs;
var TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus["Idle"] = "Idle";
  TransactionStatus["Unapproved"] = "Unapproved";
  TransactionStatus["Running"] = "Running";
  TransactionStatus["Rejected"] = "Rejected";
  TransactionStatus["Succeeded"] = "Succeeded";
  TransactionStatus["Failed"] = "Failed";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
/**
 * @hidden
 */


var TransactionQueueStatus;

(function (TransactionQueueStatus) {
  TransactionQueueStatus["Idle"] = "Idle";
  TransactionQueueStatus["Running"] = "Running";
  TransactionQueueStatus["Failed"] = "Failed";
  TransactionQueueStatus["Succeeded"] = "Succeeded";
})(TransactionQueueStatus = exports.TransactionQueueStatus || (exports.TransactionQueueStatus = {}));
/**
 * Check to see if an object is a Plain Old Javascript Object (POJO)
 */


function isPojo(pojo) {
  if (!pojo) {
    return false;
  }

  var props = Object.getOwnPropertyNames(pojo);
  return props.every(function (prop) {
    return typeof pojo[prop] !== 'function';
  }) && lodash_1.isPlainObject(pojo);
}

exports.isPojo = isPojo;
var TransactionSpeed;

(function (TransactionSpeed) {
  TransactionSpeed["Slow"] = "Slow";
  TransactionSpeed["Medium"] = "Medium";
  TransactionSpeed["Fast"] = "Fast";
  TransactionSpeed["Fastest"] = "Fastest";
})(TransactionSpeed = exports.TransactionSpeed || (exports.TransactionSpeed = {}));

var Feature;

(function (Feature) {
  Feature["Permissions"] = "Permissions";
  Feature["Tokenholders"] = "Tokenholders";
  Feature["Dividends"] = "Dividends";
  Feature["TokenholderCountRestrictions"] = "TokenholderCountRestrictions";
  Feature["PercentageOwnershipRestrictions"] = "PercentageOwnershipRestrictions";
})(Feature = exports.Feature || (exports.Feature = {}));

var SecurityTokenRole;

(function (SecurityTokenRole) {
  SecurityTokenRole["PermissionsAdministrator"] = "PermissionsAdministrator";
  SecurityTokenRole["DividendsOperator"] = "DividendsOperator";
  SecurityTokenRole["DividendsAdministrator"] = "DividendsAdministrator";
  SecurityTokenRole["TokenholdersAdministrator"] = "TokenholdersAdministrator";
  SecurityTokenRole["TokenholderCountRestrictionsAdministrator"] = "TokenholderCountRestrictionsAdministrator";
  SecurityTokenRole["PercentageOwnershipRestrictionsAdministrator"] = "PercentageOwnershipRestrictionsAdministrator";
})(SecurityTokenRole = exports.SecurityTokenRole || (exports.SecurityTokenRole = {}));

var StoRole;

(function (StoRole) {
  StoRole["StoOperator"] = "StoOperator";
  StoRole["StoAdministrator"] = "StoAdministrator";
})(StoRole = exports.StoRole || (exports.StoRole = {}));

var TransferStatusCode;

(function (TransferStatusCode) {
  TransferStatusCode["TransferFailure"] = "TransferFailure";
  TransferStatusCode["TransferSuccess"] = "TransferSuccess";
  TransferStatusCode["InsufficientBalance"] = "InsufficientBalance";
  TransferStatusCode["InsufficientAllowance"] = "InsufficientAllowance";
  TransferStatusCode["TransfersHalted"] = "TransfersHalted";
  TransferStatusCode["FundsLocked"] = "FundsLocked";
  TransferStatusCode["InvalidSender"] = "InvalidSender";
  TransferStatusCode["InvalidReceiver"] = "InvalidReceiver";
  TransferStatusCode["InvalidOperator"] = "InvalidOperator";
})(TransferStatusCode = exports.TransferStatusCode || (exports.TransferStatusCode = {}));